"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableVariants = exports.availableSeverities = exports.variants = exports.severities = void 0;
var severities = Object.freeze({
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  SUCCESS: "success"
});
exports.severities = severities;
var variants = Object.freeze({
  LOUD: "filled",
  OUTLINED: "outlined",
  QUIET: "standard"
});
exports.variants = variants;
var availableSeverities = Object.freeze(Object.values(severities));
exports.availableSeverities = availableSeverities;
var availableVariants = Object.freeze(Object.values(variants));
exports.availableVariants = availableVariants;
var componentArgs = {
  icon: {
    table: {
      disable: true
    }
  },
  severity: {
    defaultValue: severities.ERROR,
    description: "The severity of the alert message",
    options: availableSeverities,
    type: "select",
    table: {
      defaultValue: {
        summary: severities.ERROR
      }
    }
  },
  variant: {
    defaultValue: variants.QUIET,
    description: "Renders the different variants",
    options: availableVariants,
    type: "select",
    table: {
      defaultValue: {
        summary: variants.QUIET
      }
    }
  }
};
exports.componentArgs = componentArgs;